<!-- TODO: some svedit fields are non-syncing, evaluate and replace where necessary  -->
<div class="svedit svedit-component" data-hook="svedit-component">
  <form name="patsvdata">
    <div class="row">
      <!-- Geburtsdatum -->
      <div class="form-group col-xs-12 col-md-3">
        <label for="birthdate">Geburtsdatum
          <sprhelp tip="Eingabeformat" descref="vm.bdatehelp"></sprhelp>
          <span ng-show="vm.bdateerror" style="color: #cc3333"><i class="fa fa-warning"></i> {{vm.bdateerror}}</span>
        </label>

        <input ng-show="!vm.svdata.bdateat  || vm.svdata.bdateat === 'Invalid date'"
               type="text" ng-model="vm.svdata.birthdate" tabindex="0"
               ng-blur="vm.formatbdate(vm.svdata.birthdate)"
               class="form-control" id="birthdate"
               ng-focus="vm.setCurrentField('birthdate')"
               ng-change="vm.setCurrentFieldContent(vm.svdata.birthdate)"
               placeholder="TTMMJJJJ">

        <div class="input-group" ng-show="vm.svdata.bdateat  && vm.svdata.bdateat !== 'Invalid date'">
          <input type="text" class="form-control"
                 id="birthdate"
                 readonly
                 ng-model="vm.svdata.bdateat">
          <span class="input-group-btn">
        <button class="btn btn-danger"
                ng-click="vm.clearbdate()"><i class="fa fa-remove"></i>
        </button>
      </span>
        </div>
      </div>


      <!-- SVNr -->
      <div class="form-group col-xs-12 col-md-3">
        <label for="svnr">SVNr
          <sprhelp tip="Eingabeformat: NNNN -&gt;| TTMMJJ"></sprhelp>
          <span ng-hide="vm.isvalidsvnr === true"
                class="text-danger"><i class="fa fa-warning"></i> SVNr ist ungültig!</span>
          <span ng-show="vm.isvalidsvnr === true"
                class="text-success"><i class="fa fa-check"></i> SVNr ist gültig!</span>
        </label>
        <span style="display: block"
              ng-hide="vm.svdata.svnr  && vm.isvalidsvnr">
          <input type="text" ng-model="vm.svdata.svnrlfd"
                 tabindex="0"
                 ng-change="vm.isvalidsvnr = vm.formatSVNR();"
                 ng-blur="vm.isvalidsvnr = vm.formatSVNR(); vm.save();"
                 style="width: 30%; display: inline;"
                 class="form-control" id="svnrlfd"
                 placeholder="NNNN"><!-- do not remove this comment
      --><input type="text" ng-model="vm.svdata.bdatesv" tabindex="0"
                ng-change="vm.isvalidsvnr = vm.formatSVNR();"
                ng-blur="vm.isvalidsvnr = vm.formatSVNR(); vm.save();"
                style="width: 60%; display: inline;"
                class="form-control" id="bdatesv" placeholder="DDMMJJ"></span>

        <div class="input-group" ng-show="vm.svdata.svnr  && vm.isvalidsvnr">
          <input type="text" class="form-control"
                 id="svnr"
                 readonly
                 ng-model="vm.svdata.svnr">
          <span class="input-group-btn">
        <button class="btn btn-danger"
                ng-click="vm.clearSVNR()"><i class="fa fa-remove"></i>
        </button>
      </span>
        </div>

      </div>

      <!-- Rezeptgebührenbefreiung -->
      <div class="row">
        <div class="form-group col-xs-12 col-md-6">
          <label for="feefree">Rezeptgebührenbefreiung</label>
          <div class="checkbox">
            <label>
              <input type="checkbox" ng-model="vm.svdata.feefree" tabindex="0"
                     ng-blur="vm.save()"
                     id="feefree"
              >&nbsp;befreit
            </label>
          </div>
        </div>
      </div>
    </div>

    <!-- SV -->
    <div class="row">
      <!-- Sozialversicherung -->
      <div class="col-xs-2 col-md-2">

        <label for="sv">Sozialversicherung</label>
        <svsearch ng-hide="vm.svdata.sv.short"
                  sv="vm.svdata.sv"
                  svref="vm.svdata.svref"
                  parentsave="vm.svsave(sv, svref)"
                  ti="0" id="sv"></svsearch>
        <div class="input-group"
             ng-show="vm.svdata.sv.short">
          <input type="text" class="form-control"
                 id="svs"
                 readonly
                 ng-model="vm.svdata.sv.short">
          <span class="input-group-btn">
            <button class="btn btn-danger"
                    ng-click="vm.clearSV()"><i class="fa fa-remove"></i>
            </button>
          </span>
        </div>

      </div>
      <!-- Versichertengruppe -->
      <div class="form-group col-xs-9 col-md-4">
        <label for="svstatus">Versichertengruppe</label>
        <select ng-model="vm.svdata.svstatus" tabindex="0"
                ng-blur="vm.save()"
                class="form-control" id="svstatus">
          <option value="01">01 - Erwerbstätig, Arbeitslos, Selbstversichert</option>
          <option value="02">02 - Pensionist(in)</option>
          <option value="03">03 - Kriegshinterbliebene(r)</option>
          <option value="05">05 - Angehörige(r) von 01</option>
          <option value="06">06 - Angehörige(r) von 02</option>
          <option value="08">08 - Anspruch KOVG, OFG, HVG D u. DH</option>
          <option value="10">10 - VAEB (A/B), BVA</option>
          <option value="11">11 - Angehörige(r) von 10</option>
          <option value="12">12 - Sozialversicherungsabkommen</option>
        </select>
      </div>

      <!-- Arbeitgeber -->
      <div class="form-group col-xs-12 col-md-6">
        <label for="employer">Arbeitgeber</label>
        <vcinput model="vm.svdata.employer" id="employer" placeholder="Arbeitgeber"
                 parentsave="vm.childsave(key, value)">
      </div>

    </div>

    <!-- Mitversicherung -->
    <div class=" row">
      <div class="form-group col-xs-12 col-md-6">
        <label for="insuredname">Mitversichert bei (Name)</label>
        <input type="text" ng-model="vm.svdata.insuredwith.name" tabindex="0"
               ng-blur="vm.save()"
               class="form-control" id="insuredname"
               placeholder="Name">
      </div>
      <div class="form-group col-xs-12 col-md-6">
        <label for="insurednr">Mitversichert bei (SVNr)
          <span ng-show="vm.inswvalid === false" class="text-danger"><i
            class="fa fa-warning"></i> SVNr ist ungülitg!</span>
          <span ng-show="vm.inswvalid === true" class="text-success"><i class="fa fa-check"></i> SVNr ist gülitg!</span>
        </label>
        <input type="text" ng-model="vm.svdata.insuredwith.svnr" tabindex="0"
               ng-blur="vm.inswvalid = vm.validateSVNR(vm.svdata.insuredwith.svnr); vm.save();"
               ng-change="vm.inswvalid = vm.validateSVNR(vm.svdata.insuredwith.svnr);"
               class="form-control" id="insurednr"
               placeholder="SVNr">
      </div>
    </div>

    <!-- Andere Versicherungen -->
    <div class=" row">
      <!-- Versicherungsnummer -->
      <div class="form-group col-xs-12 col-md-6">
        <label for="insurancenr">Versicherungsnummer
          <sprhelp
            tip="Versicherungsnummer bei Privatversicherung od. ausländischem Versicherungsträger"></sprhelp>
        </label>
        <vcinput model="vm.svdata.insurancenr" id="insurancenr" placeholder="Versicherungsnummer"
                 parentsave="vm.childsave(key, value)">
      </div>
      <!-- Versicherungsträger -->
      <div class="form-group col-xs-12 col-md-6">
        <label for="insuranceprov">Versicherungsträger
          <sprhelp tip="Privatversicherung od. ausländischer Versicherungsträger"></sprhelp>
        </label>
        <vcinput model="vm.svdata.insuranceprov" id="insuranceprov" placeholder="Versicherung"
                 parentsave="vm.childsave(key, value)">
      </div>
    </div>

    <!-- Ärzte -->
    <div class=" row">
      <!-- Hausarzt- -->
      <div class="form-group  col-md-6" ng-hide="vm.svdata.practdoctor._id">
        <label for="doctor">Hausarzt</label>
        <doctorsearch id="doctor" parentsave="vm.savePractDoctor(doctor)"></doctorsearch>
      </div>
      <div class="form-group col-md-6" ng-show="vm.svdata.practdoctor._id">
        <label for="pdoctorname">Hausarzt</label>

        <div class="input-group">
          <input type="text" class="form-control"
                 id="pdoctorname"
                 readonly
                 ng-model="vm.svdata.practdoctor.fname">
          <span class="input-group-btn">
                    <button class="btn btn-danger"
                            ng-click="vm.clearPractDoctor()"><i class="fa fa-remove"></i>
                    </button>
                </span>
        </div>
      </div>
      <!-- Überweisender Arzt -->
      <div class="form-group  col-md-6" ng-hide="vm.svdata.refdoctor._id">
        <label for="refdoctor">Überweisender Arzt</label>
        <doctorsearch id="refdoctor" parentsave="vm.saveRefDoctor(doctor)"></doctorsearch>
      </div>
      <div class="form-group col-md-6" ng-show="vm.svdata.refdoctor._id">
        <label for="rdoctorname">Überweisender Arzt</label>

        <div class="input-group">
          <input type="text" class="form-control"
                 id="rdoctorname"
                 readonly
                 ng-model="vm.svdata.refdoctor.fname">
          <span class="input-group-btn">
                    <button class="btn btn-danger"
                            ng-click="vm.clearRefDoctor()"><i class="fa fa-remove"></i>
                    </button>
                </span>
        </div>
      </div>
    </div>

    <!-- Baisdaten-->
    <div class="row">
      <!-- Größe -->
      <div class="form-group col-md-4">
        <div class="form-group">
          <label for="height">Größe (cm)</label>
          <input type="number" id="height" ng-model="vm.svdata.height"
                 tabindex="0"
                 class="form-control" ng-blur="vm.setBMI()"/>
        </div>
      </div>
      <!-- Gewicht -->
      <div class="form-group col-md-4">
        <div class="form-group">
          <label for="weight">Gewicht (kg)</label>
          <input type="number" id="weight" ng-model="vm.svdata.weight"
                 tabindex="0"
                 class="form-control" ng-blur="vm.setBMI()"/>
        </div>
      </div>
      <!-- BMI -->
      <div class="form-group col-md-4">
        <div class="form-group">
          <label for="bmi">BMI
            <sprhelp tip="Wird automatisch aus Gewicht und Größe ermittelt"></sprhelp>
          </label>
          <input type="number" id="bmi" ng-model="vm.svdata.bmi" step="0.1" readonly class="form-control"/>
        </div>
      </div>
    </div>
  </form>
</div>